<div class="not-found-container">

  <!-- Illustration -->
  <div class="illustration-side">
    <svg viewBox="0 0 520 380" xmlns="http://www.w3.org/2000/svg" class="plug-svg">

      <!-- Cords -->
      <path d="M183,252 C162,280 198,305 162,330 C130,352 148,368 122,376"
            fill="none" stroke="#1e2461" stroke-width="7" stroke-linecap="round"/>
      <path d="M341,252 C364,280 328,305 362,330 C394,352 376,368 400,376"
            fill="none" stroke="#1e2461" stroke-width="7" stroke-linecap="round"/>

      <!-- Halo glow behind left plug -->
      <circle cx="183" cy="200" r="78" fill="#dde0f0" opacity="0.85"/>

      <!-- ══════ LEFT PLUG (lavender) ══════ -->
      <!-- Vertical prongs -->
      <rect x="164" y="106" width="13" height="36" rx="5.5" fill="#7277b0"/>
      <rect x="187" y="106" width="13" height="36" rx="5.5" fill="#7277b0"/>
      <!-- Neck connector -->
      <rect x="157" y="138" width="54" height="24" rx="10" fill="#9096c8"/>
      <!-- Body -->
      <rect x="147" y="158" width="72" height="96" rx="18" fill="#9096c8"/>
      <!-- Body inner highlight -->
      <rect x="156" y="167" width="26" height="79" rx="11" fill="white" opacity="0.13"/>
      <!-- Eyes -->
      <circle cx="173" cy="202" r="7.5" fill="#5e6298"/>
      <circle cx="197" cy="202" r="7.5" fill="#5e6298"/>
      <!-- Eye shine -->
      <circle cx="176" cy="199" r="2.8" fill="white" opacity="0.8"/>
      <circle cx="200" cy="199" r="2.8" fill="white" opacity="0.8"/>
      <!-- Smile -->
      <path d="M167,218 Q185,233 205,218"
            fill="none" stroke="#5e6298" stroke-width="3.8" stroke-linecap="round"/>

      <!-- ══════ SPARKS / LIGHTNING ══════ -->
      <g class="sparks">
        <!-- Bolt 1 -->
        <polyline points="234,176 245,161 240,178 255,161"
                  fill="none" stroke="#f5c518" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
        <!-- Bolt 2 -->
        <polyline points="236,200 247,185 242,200 255,185"
                  fill="none" stroke="#f5c518" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.7"/>
        <!-- Glow dots -->
        <circle cx="228" cy="190" r="4.5" fill="#f5c518"/>
        <circle cx="260" cy="168" r="3.2" fill="#f5c518" opacity="0.75"/>
        <circle cx="230" cy="208" r="2.5" fill="#f5c518" opacity="0.55"/>
      </g>

      <!-- ══════ RIGHT PLUG (navy) ══════ -->
      <!-- Horizontal prongs pointing left -->
      <rect x="267" y="178" width="37" height="13" rx="5.5" fill="#161b50"/>
      <rect x="267" y="201" width="37" height="13" rx="5.5" fill="#161b50"/>
      <!-- Neck connector (top) -->
      <rect x="313" y="138" width="54" height="24" rx="10" fill="#1e2461"/>
      <!-- Body -->
      <rect x="303" y="158" width="72" height="96" rx="18" fill="#1e2461"/>
      <!-- Body inner highlight -->
      <rect x="312" y="167" width="26" height="79" rx="11" fill="white" opacity="0.08"/>
      <!-- Eyes -->
      <circle cx="329" cy="202" r="7.5" fill="white" opacity="0.88"/>
      <circle cx="353" cy="202" r="7.5" fill="white" opacity="0.88"/>
      <!-- Eye shine -->
      <circle cx="332" cy="199" r="2.8" fill="#1e2461" opacity="0.55"/>
      <circle cx="356" cy="199" r="2.8" fill="#1e2461" opacity="0.55"/>
      <!-- Smile -->
      <path d="M323,218 Q341,233 361,218"
            fill="none" stroke="white" stroke-width="3.8" stroke-linecap="round" opacity="0.72"/>

    </svg>
  </div>

  <!-- Content -->
  <div class="content-side">
    <div class="error-code">404</div>
    <h1 class="error-title">Page Not Found</h1>

    <div class="error-alert">
      <span class="alert-icon">&#9888;</span>
      <div class="alert-text">
        <p>We're sorry, the page you requested could not be found.</p>
        <p>Please go back to the home page.</p>
      </div>
    </div>

    <button class="go-home-btn" (click)="goHome()">GO HOME</button>
  </div>

</div>
